<template>
  <div id = "app">
    <!-- this waypoint has to be here beacuse it can't be inside a component because it could move when the component repositions -->
    <div v-if="hasHoverBar" class="hoverbar-waypoint" v-waypoint="{ active: true, callback: stopHoverBar, options: intersectionOptions }"></div>
    <div :class=" { mainContentMargin: hoverBar.fixed && !hoverBar.value}">
      <router-view></router-view>
    </div>
    <ToTopArrow :hoverBar="!hoverBar.value"/>
    <HoverBar @hideBar="hideHoverBar" v-if="!hoverBar.value && hasHoverBar" :hoverBarData="hoverBar"></HoverBar>
    <Footer @stop="stopHoverBar"></Footer>
  </div>
</template>


<script>
import NormalHeader from '@/components/global-components/NormalHeader'
import InvertedHeader from '@/components/global-components/InvertedHeader'
import Footer from '@/components/global-components/Footer'
import HoverBar from '@/components/global-components/HoverBar'
import ToTopArrow from '@/components/widgets/ToTopArrow'
import pathPrefix from '@/pathPrefix.js' 

export default {
  components: {
    NormalHeader,
    InvertedHeader,
    Footer,
    HoverBar,
    ToTopArrow
  },
  data() {
    return {
      hasHoverBar: window.innerWidth < 600 ? false : false,
      header: {
        transparent: true
      },
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        thresholds: [0]
      },
      hoverBar: {
        value: false,
        fixed: false,
        text: "This is a hoverbar used for displaying floating text, such as deadlines for registration or other sort of information you wish to display. It can be closed at any time."
      }
    }
  },
  methods: {
    hideHoverBar() {
      this.hoverBar.value = !this.hoverBar.value;
    },
    stopHoverBar({ going, direction }) {
      var directionTop = this.$waypointMap.DIRECTION_TOP;
      var directionBottom = this.$waypointMap.DIRECTION_BOTTOM;
      var goingIn = this.$waypointMap.GOING_IN;
      var goingOut = this.$waypointMap.GOING_OUT;

      if (going === goingIn && direction === directionTop) {
        this.hoverBar.fixed = !this.hoverBar.fixed;
      }
      if (going === goingOut && direction === directionBottom) {
        this.hoverBar.fixed = !this.hoverBar.fixed;
      }
    }
  }
}
</script>


<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.hoverbar-waypoint {
  position: absolute;
  bottom: 25vh;
  z-index: 1;
}
.mainContentMargin {
  margin-bottom: 16vh;
}

@media screen and (max-height: 800px) {
  .mainContentMargin {
    margin-bottom: 25vh;
  }
}
</style>
